import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class FileService {
    API_DOCUMENT_URL = config.serverAddress + ':' + config.serverPort + '/file/';

    constructor(private http: HttpClient) { }

    upload(formData: FormData) {
        return this.http.post(this.API_DOCUMENT_URL + 'upload', formData);
    }
    /**
     * Con entrambi gli ID il back-end serve la copia della pratica e ripiega
     * sul master del cliente solo se quella manca.
     */
    download(idRequest: string | null, idDocumentType: string, filePath: string, idCustomer: string | null = null) {
        const body: any = { IDDocumentType: idDocumentType, FilePath: filePath };
        if (idRequest) {
            body.IDRequest = idRequest;
        }
        if (idCustomer) {
            body.IDCustomer = idCustomer;
        }
        return this.http.post(this.API_DOCUMENT_URL + 'download', body, { responseType: 'blob'});
    }
    downloadStatic(filePath: string) {
        return this.http.post(this.API_DOCUMENT_URL + 'download-static', { FilePath: filePath }, { responseType: 'blob'});
    }
}
